/**
 * Surprise Me eligibility figures. Dependency-free on purpose (see
 * `ratingThresholds.ts`): the member-facing explainer copy reads them, and
 * `restaurantUtils.tsx` re-exports them for existing imports.
 */

/**
 * Minimum number of TasteMatch scores Surprise Me needs to see before it
 * spins on TasteMatch alone (paire-app#104 item 1). Below this, the member's
 * own scores are too thin to fill a spin, so Surprise Me falls back to
 * public opinion for restaurants that have no TasteMatch score yet.
 *
 * Counted over the restaurants the member is currently looking at (see
 * `selectSurpriseMePool`'s `countScope`), not a platform-wide per-member
 * total: TasteMatch scores are computed per request rather than stored
 * per member, so no member-level count exists to read.
 */
export const SURPRISE_ME_MIN_TASTEMATCH_SCORES = 5;

/**
 * The fewest eligible restaurants a Surprise Me spin needs. With one there is
 * nothing to choose between, and with none there is nothing to land on, so a
 * trigger stays hidden until its pool reaches this size (paire-app#104
 * follow-up). Every surface reads it through `useSurpriseMeLauncher`'s
 * `isAvailable`, never by recounting.
 */
export const SURPRISE_ME_MIN_POOL_SIZE = 2;
